import {createAction} from 'redux-actions';
import {curry} from 'ramda';
import tryToCatch from 'try-to-catch';
import {
    getDeliveryJobs,
    retryDeliveryJob,
    cancelDeliveryJob,
    getDeliverySummary,
} from '@pluto/rest';
import {setNotificationAction as setNotification} from '@pluto/notification';
import {SummaryPromise} from '@pluto/common/summary';
import {QueryParams} from '../DeliveryManagerTypes';
import {dateToUtc} from '../../QCManager/Redux/QCManagerActions';

export const SET_DELIVERY_JOBS = 'SET_DELIVERY_JOBS';
export const RESET_DELIVERY_JOBS = 'RESET_DELIVERY_JOBS';
export const DELIVERY_MANAGER_SUMMARY_SET = 'DELIVERY_MANAGER_SUMMARY_SET';

export const getRequestBody = (params: QueryParams) => {
    const {
        startDateStart,
        startDateEnd,
        finishDateEnd,
        finishDateStart,
        qcJobStatus,
        ...restParams
    } = params;
    return {
        'deliveryJob.startDateFrom': dateToUtc('start', startDateStart),
        'deliveryJob.startDateTo': dateToUtc('end', startDateEnd),
        'deliveryJob.finishDateFrom': dateToUtc('start', finishDateStart),
        'deliveryJob.finishDateTo': dateToUtc('end', finishDateEnd),
        'deliveryJob.status': qcJobStatus,
        ...restParams,
    };
};

export const setDeliveryJobs = createAction(
    SET_DELIVERY_JOBS,
    async (params: QueryParams) => {
        const body = getRequestBody(params);

        return await getDeliveryJobs(body);
    }
);

export const resetDeliveryJobs = createAction(RESET_DELIVERY_JOBS);

export const retryTask = curry(async (id: number, params: QueryParams, dispatch) => {
    const [error] = await tryToCatch(retryDeliveryJob, id);

    if (!error) {
        dispatch(
            setNotification({
                type: 'success',
                text: 'Delivery job has been restarted',
            })
        );

        dispatch(setDeliveryJobs(params));
    } else {
        const {data: errorData} = error.response;

        dispatch(
            setNotification({
                type: 'error',
                text: errorData.message,
            })
        );
    }
});

export const cancelTask = curry(async (id: number, params: QueryParams, dispatch) => {
    const [error] = await tryToCatch(cancelDeliveryJob, id);

    if (!error) {
        dispatch(
            setNotification({
                type: 'success',
                text: 'Delivery job has been canceled',
            })
        );

        dispatch(setDeliveryJobs(params));
    } else {
        const {data: errorData} = error.response;

        dispatch(
            setNotification({
                type: 'error',
                text: errorData.message,
            })
        );
    }
});

export const getDeliverySummaryAction = createAction<SummaryPromise>(
    DELIVERY_MANAGER_SUMMARY_SET,
    async () => {
        return await getDeliverySummary();
    }
);
